import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 10, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.59 0L4 6.59L1.41 4.01L0 5.42L4 9.42L12 1.42L10.59 0Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
